import angular from 'angular';

import CalendarModule from './calendar';
import SettingsModule from './settings';
import SubscribeModule from './subscribe';
import PaymentModule from './payment';
import TeamShareModule from './team-share';
import DashboardModule from './dashboard';

export default angular
    .module('application.scene.authorized.scene', [
        CalendarModule.name,
        SettingsModule.name,
        SubscribeModule.name,
        PaymentModule.name,
        TeamShareModule.name,
        DashboardModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/index.js